import { createContext, useContext } from 'react'

interface BreadcrumbsContextType {
  setBreadcrumbs: (breadcrumbs: React.ReactNode) => void
  clearBreadcrumbs: () => void
}

export const BreadcrumbsContext = createContext<BreadcrumbsContextType | null>(
  null
)

export function useBreadcrumbs() {
  const context = useContext(BreadcrumbsContext)
  if (!context) {
    throw new Error('useBreadcrumbs must be used within a BreadcrumbsProvider')
  }
  return context
}
